var Backbone = require('backbone');
var _ = require('underscore');

var Page = require('front/pages/Page/Page');
var Section = require('front/pages/Section/Section');
var Utils = require('front/utils/Utils');

require('./About.less');

module.exports = Section.extend({

    title: 'Робот-художник • О проекте',

    el: '.About',

    events: {
    },

    onYouTubeIframeAPIReadyOld: undefined,

    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    },

    activate: function () {
        console.log('activate About');

        return Section.prototype.activate.call(this);
    },


    deactivate: function (params) {
        console.log('deactivate About');

        return Section.prototype.deactivate.call(this, params);
    },


    render: function () {
        console.log('render About');
        var result = Section.prototype.render.call(this);

        if (this.options.inAnimated) {
            this.$el.css({opacity: 0});
        }

        return result;
    },


    playIn: function (params) {
        console.log('playIn About');

        var self = this;

        if (this.options.inAnimated) {
            return new Promise(function (resolve) {

                self.$el.css({opacity: 1});

                self.playInResolve = resolve;

                self.playInTimeout = setTimeout(function () {
                    delete self.playInTimeout;
                    resolve();
                }, 400);
            });
        } else {
            return Utils.createEmptyPromise();
        }
    },


    playOut: function (params) {
        console.log('playOut About');

        if (this.playInTimeout) {
            clearTimeout(this.playInTimeout);
            this.playInResolve && this.playInResolve();
            delete this.playInTimeout;
            delete this.playInResolve;
        }

        var self = this;

        return new Promise(function (resolve) {
            self.$el.animate({opacity:0}, params.duration, function () {
                resolve();
            });
        });
    }

});




//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/About/About.js
// module id = 32
// module chunks = 0